export const getGoogleMapsDirectionsURL = (lat, lng) => `https://www.google.com/maps?daddr=${lat},${lng}`;
export const getGoogleMapsDestinationURL = (lat, lng) => `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
